<template lang="pug">
  .lesson-test-question
    .lesson-test-question__img(
      v-if="question.img.url"
      :style="{backgroundImage: `url('`+question.img.url+`')`}"
    )
    .lesson-test-question__text.form-item__markdown(
      v-html="makeHtml(question.text)"
    )

    .lesson-test-question__answers
      Answer(
        v-for="answer in randomAnswers" :key="answer.id"
        :propAnswer="answer"
        :choosingArray="getChoosingArray"
        :propSelectedAnswer="isActiveAnswer(answer.id)"
        :isMultipleAnswers="question.isMultipleAnswers"
        @selectAnswer="selectAnswer(answer.id)"
      )

</template>

<script>
import _ from 'lodash';
import markdownToHtml from '@/functions/converterMarkdownToHtml';
import Answer from './Answer';

export default {
  components: { Answer },
  props: ['propQuestion', 'isChecking'],
  data: () => ({
    question: {
      img: {},
      text: '',
      isMultipleAnswers: undefined,
      userAnswerIds: []
    }
  }),
  computed: {
    randomAnswers() {
      return _.shuffle(this.question.answers);
    },
    getChoosingArray() {
      return this.isChecking ? this.question.userAnswerIds : [];
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.question = _.cloneDeep(this.propQuestion);
    },
    makeHtml(value) {
      return markdownToHtml.makeHtml(value);
    },
    selectAnswer(answerId) {
      if (this.isChecking) {
        return;
      }
      const idx = this.question.userAnswerIds.indexOf(answerId);

      if (this.question.isMultipleAnswers) {
        if (idx === -1) {
          this.question.userAnswerIds.push(answerId);
        } else {
          this.question.userAnswerIds.splice(idx, 1);
        }
      } else {
        if (idx === -1) {
          this.question.userAnswerIds = [];
          this.question.userAnswerIds.push(answerId);
        }
      }
      this.$emit('updateUserAnswerIds', this.question.userAnswerIds);
    },
    isActiveAnswer(answerId) {
      return this.question.userAnswerIds.includes(answerId);
    }
  }
};
</script>
